//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import // XButton,
// XInput,
    "vux";
  import { mapState } from "vuex";
  import { service, nativeApi } from "@/common/index";
  import { fetch } from "@/page/index";
  import { syncResponsibilitySession } from "@/utils/responsibilityUtils";
  import { Dialog } from "vant";

  export default {
    data() {
      return {
        showRespPicker: false,
        showLanPicker: false,
      };
    },
    components: {},
    computed: {
      ...mapState({
        userInfo: (state) => state.user.userInfo,
        responsibilityId: (state) => state.user.responsibilityId,
        languageCode: (state) => state.user.languageCode,
      }),
      responsibility: {
        get() {
          if (this.userInfo == null) {
            return "";
          }
          const role = this.userInfo.userRespList.find(
            (item) => item.responsibilityId === this.responsibilityId
          );
          return role != null ? role.responsibilityName : "";
        },
        set(val) {},
      },
      respActions() {
        const userRespList = (this.userInfo && this.userInfo.userRespList) || [];
        const mobileList = userRespList.filter(
          (item) => item.systemCode === "MOBILE"
        );
        const respList = mobileList.length ? mobileList : userRespList;
        return respList.map((item) => ({
          name: item.responsibilityName,
          responsibilityId: item.responsibilityId,
        }));
      },
      lanActions() {
        const lanList = (this.userInfo && this.userInfo.languageList) || [];
        return lanList.map((item) => ({
          name: item.meaning,
          code: item.lookupCode,
        }));
      },
      language: {
        get() {
          if (this.userInfo == null) {
            return "";
          }
          const lan = this.userInfo.languageList.find(
            (item) => item.lookupCode == this.languageCode
          );
          return lan != null ? lan.meaning : "";
        },
        set(val) {},
      },
    },
    created() {},
    activated: function () {
      this.initView();
      this.handleWxCode();
      this.handlePendingWxBind();
    },
    methods: {
      initView() {
        // 保留钩子，供 activated / mounted 调用（微信绑定等场景）
      },
      onChangeResp() {
        if (!this.respActions.length) {
          Dialog.alert({ message: "暂无可用职责" });
          return;
        }
        this.showRespPicker = true;
      },
      onChangeLan() {
        if (!this.lanActions.length) {
          Dialog.alert({ message: "暂无可用语言" });
          return;
        }
        this.showLanPicker = true;
      },
      async onSelectResp(action) {
        if (!action || action.responsibilityId == null) return;
        if (action.responsibilityId === this.responsibilityId) return;

        const toast = this.$toast.loading({
          message: "切换中...",
          forbidClick: true,
          duration: 0,
        });
        try {
          const result = await syncResponsibilitySession(
            this.$store,
            action.responsibilityId,
            this.languageCode
          );
          toast.clear();
          if (!result.success) {
            Dialog.alert({ message: result.message || "切换职责失败" });
          }
        } catch (err) {
          toast.clear();
          Dialog.alert({ message: "切换职责失败，请重试" });
        }
      },
      onSelectLan(action) {
        if (!action || !action.code) return;
        this.$store.commit("SET_LANGUAGE", action.code);
      },
      onAbout() {
        Dialog.alert({
          title: "关于我们",
          message: "版本: SRM4.0 \n版权所有: 广州赛意信息科技股份有限公司",
        });
      },
      onLogout() {
        Dialog.confirm({
          message: "是否确认注销登录",
        }).then(() => {
            //todo: 确认注销
            localStorage.removeItem("userInfo");
            this.$store.commit("LOGOUT");
            this.$router.push("/srmLogin");
          })
          .catch(() => {
            //todo: 取消
          });
      },
      bindWx() {
        localStorage.wxCode = null;
        let ua = window.navigator.userAgent.toLowerCase();
        // 微信环境
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          // 构建微信授权URL，回调到 mine 页面并带上 action=bindWx 标记
          // 这样登录页不会尝试微信登录，而是让 mine 页面处理绑定
          let _authorize = "https://m.srm.hibr.com.cn/mine?action=bindWx"
          let appId = "wx2755722dfd43c945"
          let _wechatUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri="
          _wechatUrl += encodeURIComponent(_authorize)
          _wechatUrl += "&response_type=code&scope=snsapi_base&state=bindWx&connect_redirect=1#wechat_redirect"
          console.log("绑定微信授权URL:" + _wechatUrl);
          window.location.href = _wechatUrl
        } else {
          Dialog.alert({
            title: "用户提示",
            message: "请使用微信浏览器绑定"
          });
        }
      },
      //解除微信绑定
      relieveBindWx() {
        Dialog.confirm({
          message: "是否解除微信绑定",
        })
          .then(() => {
            let param = {
              userId : this.userInfo.userId,
              wxOpenId : ""
            }
            fetch.updateWxOpenIdById(param).then(res=>{
              localStorage.wxCode = null;
              if (res.status === "S") {
                this.$set(this.userInfo, "wxOpenId", "");
                Dialog.alert({
                  title: "用户提示",
                  message: "解绑成功！"
                })
              } else {
                Dialog.alert({
                  title: "用户提示",
                  message: "解绑失败！"
                })
              }
            })
          })
          .catch(() => {
            //todo: 取消
          });
      },
      getUrlParam(paramName) {
        // 先从 Vue Router 的 query 中获取
        if (this.$route && this.$route.query && this.$route.query[paramName]) {
          return this.$route.query[paramName]
        }
        // 再从 URL search 中获取
        let params = window.location.search
        if (params.indexOf(paramName) > -1) {
          let paramValue = ''
          paramValue = params.substring(params.indexOf(paramName), params.length)
          if (paramValue.indexOf('&') > -1) {
            paramValue = paramValue.substring(0, paramValue.indexOf('&'))
          }
          paramValue = paramValue.replace(paramName + '=', '')
          return paramValue
        }
        return null
      },
      handleWxCode() {
        let code = this.getUrlParam('code');
        console.log('handleWxCode called, code:', code, 'userInfo:', this.userInfo);
        if (code) {
          // 先清除 URL 中的 code 参数，防止重复执行
          let cleanUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, document.title, cleanUrl);

          if (this.userInfo && this.userInfo.userId) {
            // 用户已登录，直接绑定微信
            this.$toast.loading({
              message: '绑定中...',
              forbidClick: true,
              duration: 0
            });
            this.wxUserInfo(code);
          } else {
            // 用户未登录，保存 code 到 localStorage，登录后再处理
            localStorage.setItem('pendingWxBindCode', code);
            console.log('User not logged in, saved code to localStorage, redirecting to login...');
            // 跳转到登录页
            this.$router.push('/srmLogin');
          }
        }
      },
      wxUserInfo(code){
        localStorage.wxCode = code;
        let param = {
          userId : this.userInfo.userId,
          code : code
        }
        fetch.wechat_userInfo(param).then(res=>{
          this.$toast.clear();
          localStorage.wxCode = null;
          if (res.status === "S") {
            this.$set(this.userInfo, "wxOpenId", "sss");
            Dialog.alert({
              title: "用户提示",
              message: "绑定成功！"
            })
          } else {
            Dialog.alert({
              title: "用户提示",
              message: res.msg || "绑定失败！"
            })
          }
        }).catch(err=>{
          this.$toast.clear();
          localStorage.wxCode = null;
          Dialog.alert({
            title: "用户提示",
            message: "绑定失败，请重试！"
          })
        })
      },
      // 处理登录后待绑定的微信 code
      handlePendingWxBind() {
        let pendingCode = localStorage.getItem('pendingWxBindCode');
        if (pendingCode && this.userInfo && this.userInfo.userId) {
          localStorage.removeItem('pendingWxBindCode');
          this.$toast.loading({
            message: '绑定中...',
            forbidClick: true,
            duration: 0
          });
          this.wxUserInfo(pendingCode);
        }
      }
    },
    watch: {
      // userInfo 异步加载完成后，检查是否有待处理的微信 code
      userInfo(newVal) {
        if (newVal && newVal.userId) {
          this.handleWxCode();
          this.handlePendingWxBind();
        }
      }
    },
    mounted() {
      this.initView();
      console.log(this.userInfo);
      this.handleWxCode();
      this.handlePendingWxBind();
    },
  };



// WEBPACK FOOTER //
// ./src/page/srm/home/mine.vue